import React from "react";
import { Fade } from "react-reveal";
import { Link } from "react-router-dom";
import "./Cta.css";

export default function Cta() {
  return (
    <Fade up>
      <div className="cta">
        <div className="container">
          <h3>
            You are not alone in this journey. Let's step into the light
            together, guiding you towards a brighter tomorrow.
          </h3>
          <Link to={"/therapists"} className="find-a-therapist">
            Find a therapist
          </Link>
        </div>
        <div className="image"></div>
      </div>
    </Fade>
  );
}
